import { useEffect, useState } from "react";
import { navItems } from "@/mocks/chiagua";

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-50 transition-all duration-300 " +
        (scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200/80 shadow-sm" : "bg-transparent")
      }
    >
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-news-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            吃瓜福利<span className="text-primary-500">会员站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={"#" + item.id}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#discuss"
            className="whitespace-nowrap rounded-full px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
          >
            登录社区
          </a>
          <a
            href="#join"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开通会员
          </a>
        </div>

        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={"#" + item.id}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="mt-3 flex items-center gap-2">
            <a
              href="#join"
              onClick={() => setOpen(false)}
              className="w-full whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              开通会员
            </a>
          </div>
        </div>
      )}
    </header>
  );
}